import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Translations
import enLocales from './en.json';
import frLocales from './fr.json';
import arLocales from './ar.json';
import wolLocales from './wol.json';

// ----------------------------------------------------------------------

let lng = 'fr';

if (localStorage.getItem('i18nextLng')) {
  lng = localStorage.getItem('i18nextLng') || 'fr';
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translations: enLocales },
      fr: { translations: frLocales },
      ar: { translations: arLocales },
      wol: { translations: wolLocales },
    },
    lng,
    fallbackLng: 'fr',
    debug: false,
    ns: ['translations'],
    defaultNS: 'translations',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
